import { useState, useEffect, useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import IconCopy from '@/components/icons/IconCopy'
import IconColorWallet from '@/components/icons/IconColorWallet'
import { popupNotificationListState } from '@/recoil/Notification'
import { useWalletSelector } from '@/contexts/WalletSelectorContext'
import useCopyToClipboard from '@/hooks/useCopyToClipboard'
import './WalletAddressBlock.css'

function WalletAddressEllipsisDisplay(s) {
  return s.length <= 20
    ? s
    : `${s.substring(0, 7)}...${s.substring(s.length - 7)}`
}

export default function WalletAddressBlock() {
  const { selector, accountId } = useWalletSelector()
  const [, copy] = useCopyToClipboard()

  const setPopupNotification = useSetRecoilState(popupNotificationListState)
  const [walletImage, setWalletImage] = useState(null)

  const copyWalletAddress = useCallback(() => {
    copy(accountId)
    setPopupNotification({
      notification: {
        key: Date.now(),
        status: 'success',
        message: 'Copied'
      }
    })
  }, [accountId, copy, setPopupNotification])

  useEffect(() => {
    if (!accountId) {
      return
    }

    selector
      .wallet()
      .then(
        ({ metadata }) => metadata?.iconUrl && setWalletImage(metadata.iconUrl)
      )
  }, [selector, accountId])

  return (
    <div className="card account-block wallet-address-block">
      <div className="block-label divider">
        <div className="block-label-icon">
          <IconColorWallet className="label-icon" />
        </div>
        Wallet Address
      </div>
      <div className="wallet-address-content">
        {walletImage && (
          <div className="wallet-icon-container">
            <img className="wallet-icon" src={walletImage} alt="wallet icon" />
          </div>
        )}
        <div className="copy-address">
          <span className="address-highlight">
            {WalletAddressEllipsisDisplay(accountId)}
          </span>
          <IconCopy className="icon-copy" onClick={copyWalletAddress} />
        </div>
      </div>
    </div>
  )
}
